"use client";

import styles from "./GDPRChangeButton.module.css";

//#region [Props]
type GDPRChangeButtonProps = {
};
//#endregion

//#region [Component]
export default function GDPRChangeButton({ }: GDPRChangeButtonProps) {
    return <button onClick={() => window?.Cookiebot?.renew()} className={styles.GDPRChangeButton}>Endre/trekk tilbake cookiesamtykke</button>;
}
//#endregion

//#region [Styles]

//#endregion